import { Grid, Row, Column } from '@dls/web';
import React from 'react';

export default function PageWrapper({
  children
}: {
  children: React.ReactNode;
}) {
  return (
    <Grid>
      <Row>
        <Column xs={12} sm={12} md={12} noGutter>
          {children}
        </Column>
      </Row>
    </Grid>
  );
}
